import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TRIGGERS, TRIGGER_VALUE_FIELDS } from 'web-interactives-data/constants/Targeting';
import { isUndefined } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TriggersDescription = ({
  triggers,
  isShowAlways
}) => {
  if (isShowAlways) {
    return /*#__PURE__*/_jsx("div", {
      children: I18n.text('targeting.triggers.showAlways.readOnly')
    }, "showAlways");
  }
  const enabledTriggers = triggers ? TRIGGERS.filter(t => triggers[t]).map(trigger => {
    const valueField = TRIGGER_VALUE_FIELDS[trigger];
    return [trigger, valueField && triggers[valueField]];
  }) : [];
  if (!enabledTriggers.length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "targeting.triggers.buttonClick.readOnly"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: enabledTriggers.map(([trigger, value]) => /*#__PURE__*/_jsx("div", {
      children: I18n.text(`targeting.triggers.${trigger}.readOnly`, !isUndefined(value) ? {
        value
      } : {
        value: 0
      })
    }, trigger))
  });
};
export default TriggersDescription;